import { render, staticRenderFns } from "./Testograf.vue?vue&type=template&id=56d6b75c&scoped=true&"
import script from "./Testograf.vue?vue&type=script&lang=ts&"
export * from "./Testograf.vue?vue&type=script&lang=ts&"
import style0 from "./Testograf.vue?vue&type=style&index=0&id=56d6b75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6b75c",
  null
  
)

export default component.exports